export const CANCEL_ANYTIME_RENT_PERCENTAGE = 0.03;
export const LEAVE_ANYTIME_RENT_PERCENTAGE = 0.0389;
export const LEAVE_ANYTIME_ONETIME_DISCOUNT = 0.0833;
export const DEFAULT_MONTHLY_PER_UNIT_FEE = 5;
export const DEFAULT_COVERAGE_LIMIT = 30000;
export const DEFAULT_COVERAGE_MONTHS = 6;
export const DEFAULT_DEDUCTIBLE = 500;
export const DEFAULT_REVSHARE_RATE = 0;
export const DEFAULT_FLAT_COMMISSION = 0;
export const DEFAULT_REQUIRED_STAY = 3;

export const BASE_RATE = 0.015; // 1.50%
export const BASE_SEVERITY = 2.35; // Base severity in months
export const BASE_FREQUENCY = 0.0294; // Base early termination rate (2.94%)
export const BASE_SEVERITY_PREMIUM = 1.25; // Base severity premium
export const BASE_FREQUENCY_PREMIUM = 1.25; // Base frequency premium
export const MIN_RATE = 0.005; // Minimum rate (0.5% of gross rent)

